/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AcquisIfapmeGridDto
 */
export interface AcquisIfapmeGridDto {
    /**
     * 
     * @type {number}
     * @memberof AcquisIfapmeGridDto
     */
    idtitreDiplomeCertificationIfapme?: number;
    /**
     * 
     * @type {string}
     * @memberof AcquisIfapmeGridDto
     */
    description?: string | null;
}

/**
 * Check if a given object implements the AcquisIfapmeGridDto interface.
 */
export function instanceOfAcquisIfapmeGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AcquisIfapmeGridDtoFromJSON(json: any): AcquisIfapmeGridDto {
    return AcquisIfapmeGridDtoFromJSONTyped(json, false);
}

export function AcquisIfapmeGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcquisIfapmeGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idtitreDiplomeCertificationIfapme': !exists(json, 'idtitreDiplomeCertificationIfapme') ? undefined : json['idtitreDiplomeCertificationIfapme'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function AcquisIfapmeGridDtoToJSON(value?: AcquisIfapmeGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idtitreDiplomeCertificationIfapme': value.idtitreDiplomeCertificationIfapme,
        'description': value.description,
    };
}

